var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMapEditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.734,
    height: 30.707,
    fill: "none",
    viewBox: "0 0 30.734 30.707",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.829 1.9062c0.8873 0.88763 0.8874 2.3167 1e-4 3.2043l-11.901 11.904-3.8176 0.6144 0.6143-3.8186 11.901-11.905c0.8873-0.88758 2.316-0.88754 3.2032 0z",
    stroke: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.269 3.2634 3.2029 3.2046",
    stroke: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.456 14.336v10.344m-2.7685 2.5317h-17.556m-2.6228-2.4915v-18.124m2.5864-2.3314h9.665",
    stroke: "#8895b5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#8895b5",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.2534 6.3822c1.1789-0.4161 1.8011-1.7017 1.3898-2.8715s-1.7004-1.7808-2.8793-1.3646c-1.1789 0.4161-1.8011 1.7017-1.3898 2.8715 0.41131 1.1698 1.7004 1.7808 2.8793 1.3646z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.2534 29.33c1.1789-0.4161 1.8011-1.7017 1.3898-2.8715s-1.7004-1.7808-2.8793-1.3647-1.8011 1.7017-1.3898 2.8715c0.41131 1.1698 1.7004 1.7808 2.8793 1.3647z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.201 29.33c1.1789-0.4161 1.8011-1.7017 1.3898-2.8715s-1.7004-1.7808-2.8793-1.3647-1.8011 1.7017-1.3898 2.8715 1.7004 1.7808 2.8793 1.3647z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapEditor);
export default __webpack_public_path__ + "static/media/icon_map_editor.7afd8d780c7155604325372b06645e11.svg";
export { ForwardRef as ReactComponent };